import apiClient from '../utils/apiClient';
import { apiUtils } from '../utils/commonUtils';

export const updateProfile = async ({ name, email, phone, position }) => {
  try {
    const response = await apiClient.put('/me', { name, email, phone: phone || null, position: position || null });
    const data = response.data;
    if (data.status === 'success' || response.status === 200) {
      return { success: true, data: data.data, message: data.message || 'Profil diperbarui.' };
    }
    throw new Error(data.message || 'Gagal memperbarui profil.');
  } catch (error) {
    return apiUtils.handleError(error, 'Gagal memperbarui profil.');
  }
};

export const changePassword = async ({ current_password, new_password, new_password_confirmation }) => {
  try {
    const response = await apiClient.post('/me/change-password', {
      current_password,
      new_password,
      new_password_confirmation,
    });
    const data = response.data;
    if (data.status === 'success' || response.status === 200) {
      return { success: true, message: data.message || 'Password berhasil diubah.' };
    }
    throw new Error(data.message || 'Gagal mengubah password.');
  } catch (error) {
    return apiUtils.handleError(error, 'Gagal mengubah password.');
  }
};
